module.exports = __webpack_public_path__ + "static/cio-on-tap-approach@2x-0da1ab303bf97be8bd73014d74250f52.jpg";